import { type ErrorComponentProps } from "@tanstack/react-router";
import { useEffect, useState } from "react";

import Button from "./Button";
import {
  attemptChunkReload,
  isChunkLoadError,
  CHUNK_RELOAD_KEY,
} from "./chunk-error";
import Link from "./Link";
import Logo from "./Logo";
import { m } from "./paraglide/messages";

export function RouteErrorFallback({ error }: ErrorComponentProps) {
  const chunkError = error instanceof Error && isChunkLoadError(error);
  const [reloadAttempted, setReloadAttempted] = useState(
    () => chunkError && sessionStorage.getItem(CHUNK_RELOAD_KEY) === "true",
  );

  useEffect(() => {
    if (!chunkError || reloadAttempted) return;

    // shared helper so a pending guard reset is cancelled before reloading
    attemptChunkReload(error);
    setReloadAttempted(true);
  }, [chunkError, reloadAttempted, error]);

  if (chunkError) {
    return (
      <div className="flex size-full flex-col items-center justify-center gap-6">
        <Logo />
        <div className="flex flex-col items-center justify-center gap-3">
          <h1 className="text-text-primary text-2xl font-bold">
            {m.app_updated()}
          </h1>
          <p className="text-text-secondary max-w-lg text-center text-sm">
            {reloadAttempted
              ? m.app_updated_refresh_failed()
              : m.app_updated_refreshing()}
          </p>
        </div>
        {reloadAttempted && (
          <Button
            onPress={() => {
              sessionStorage.removeItem(CHUNK_RELOAD_KEY);
              globalThis.location.reload();
            }}
          >
            {m.refresh_page()}
          </Button>
        )}
      </div>
    );
  }

  return (
    <div className="flex size-full flex-col items-center justify-center gap-6">
      <Logo />
      <div className="flex flex-col items-center justify-center gap-3">
        <h1 className="text-text-primary text-2xl font-bold">
          {m.error_occurred()}
        </h1>
        <p className="text-text-secondary max-w-lg text-center text-sm">
          {m.experience_issues()}
        </p>
      </div>
      <Link to="/">{m.go_to_home_button()}</Link>
    </div>
  );
}
